export const adminPatientDetailsReasons = [
    "unknown-local-authority",
    "other",
];
//# sourceMappingURL=system.js.map